export default __webpack_public_path__ + "static/media/AutoAdvance_Plus_159x150.0f77e75c.png";